(function(window, angular) {
  "use strict";

    angular.module('service')
    .factory('leadService', ['baseService', '$http', function(baseService, $http) {
        // inherits
        var extended = angular.copy(baseService);
        // url
        extended.base_url = getFullUrl('/api/lead');
        extended.base_prefix = 'int_';

        extended.initObj = function(obj) {
          if( obj !== null ) {
            obj = baseService.initObj(obj);

            if( obj.int_lead_date ) {
              obj.int_lead_date = new Date(obj.int_lead_date);
            }
            if( obj.int_date_echeance ) {
              obj.int_date_echeance = new Date(obj.int_date_echeance);
            }
          }
          return obj;
        };

        extended.statistics = function(params) {
          return $http({
            url: extended.base_url + '/statistics',
            method: 'GET',
            params: params
          }).then(function(response) {
            return response.data;
          });
        }

        return extended;
    }]);
})(window, window.angular);
